import { UserSegmentEnum } from "../types";

/**
 * Converts a UserSegmentEnum value to a human-readable label
 * @param segment The segment enum value
 * @returns A human-readable label for the segment
 */
export const getSegmentLabel = (segment: UserSegmentEnum): string => {
  const labelMap: Record<UserSegmentEnum, string> = {
    [UserSegmentEnum.TEAM]: "Team",
    [UserSegmentEnum.BETA_TESTERS]: "Beta Testers",
    [UserSegmentEnum.ADVISORY_BOARD]: "Advisory Board",
    [UserSegmentEnum.EVALUATOR]: "Evaluator",
    [UserSegmentEnum.TEST_ACCOUNT]: "Test Account",
    [UserSegmentEnum.ASU_CALM]: "ASU CALM",
    [UserSegmentEnum.CBIZ]: "CBIZ",
    [UserSegmentEnum.ASU]: "ASU",
    [UserSegmentEnum.USER_GROUP_A]: "User Group A",
    [UserSegmentEnum.USER_GROUP_B]: "User Group B",
    [UserSegmentEnum.FRIENDS_AND_FAMILY]: "Friends & Family",
    [UserSegmentEnum.NO_SEGMENT]: "No Segment",
    [UserSegmentEnum.NO_DATA]: "No Data",
  };
  return labelMap[segment];
};
